import {FormArray, FormGroup, ValidationErrors} from "@angular/forms";

export class ValidationErrorCollector {
  errors: ValidationErrors
  constructor(formGroup: FormGroup) {
    this.errors = this.collectErrors(formGroup);
  }

  private collectErrors(formGroup: FormGroup){
    let retErrors = {} as ValidationErrors;
    for(let key in formGroup.controls) {
      const controlErrors: ValidationErrors | undefined | null = formGroup.get(key)?.errors;
      if (controlErrors != null) {
        for(let keyError in controlErrors) {
          retErrors[keyError] = controlErrors[keyError];
        }
      }
      // Add errors for child controls
      if(formGroup.get(key) && (formGroup.get(key) instanceof FormGroup)){
        const innerControlErrors = this.collectErrors(formGroup.get(key) as FormGroup)
        retErrors = {
          ...retErrors,
          ...innerControlErrors
        }
      }
      else if(formGroup.get(key) && (formGroup.get(key) instanceof FormArray)){
        const innerControlErrors = this.collectErrorsInArray(formGroup.get(key) as FormArray)
        retErrors = {
          ...retErrors,
          ...innerControlErrors
        }
      }
    }
    return retErrors
  }

  private collectErrorsInArray(formArray: FormArray){
    let retErrors = {} as ValidationErrors;
    for(let control of formArray.controls) {
      const controlErrors: ValidationErrors | undefined | null = control?.errors;
      if (controlErrors != null) {
        for(let keyError in controlErrors) {
          retErrors[keyError] = controlErrors[keyError];
        }
      }
      // Add errors for child controls
      if(control && (control instanceof FormGroup)){
        const innerControlErrors = this.collectErrors(control as FormGroup)
        retErrors = {
          ...retErrors,
          ...innerControlErrors
        }
      }
      else if(control && (control instanceof FormArray)){
        const innerControlErrors = this.collectErrorsInArray(control as FormArray)
        retErrors = {
          ...retErrors,
          ...innerControlErrors
        }
      }
    }
    return retErrors
  }
}
